module.exports = __webpack_public_path__ + "static/GLSL-279041e43d54a32a804a2028e5235b08.png";